import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PosIntegrationService } from '../../../../../services/pos-integration.service';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-link-vend',
  templateUrl: './link-vend.component.html',
  styleUrls: ['./link-vend.component.scss'],
})
export class LinkVendComponent implements OnInit {
  @Input() partner;
  @Input() selectedPOS;
  @Output() next = new EventEmitter();
  public busy = false;
  public connected = false;
  public syncing = false;
  public message = null;
  public broadcastChannel = new BroadcastChannel('VEND_CHANNEL');
  public win;
  public vend_auth_url: string = null;
  public configurationSaved: boolean = false;

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    private posIntegrationService: PosIntegrationService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.posIntegrationService.getVendAuthURL().subscribe(
      (vend: any) => {
        this.vend_auth_url = vend.auth_url;
      },
      (err) => {
        this.busy = false;
        this.message = this.translate.instant(
          'onboarding.messages.vend_error_auth_url',
        );
      },
    );

    this.broadcastChannel.onmessage = (ev) => {
      if (ev.data === 'CONNECTED') {
        this.checkPOSIntegration();
        setTimeout(() => {
          this.posIntegrationService
            .startFullPOSSync(this.partner.PartnerID)
            .subscribe(
              (sync) => {},
              (err) => {},
            );
          this.posIntegrationService
            .startPOSClientSync(this.partner.PartnerID)
            .subscribe(
              (sync) => {},
              (err) => {},
            );
        }, 10000);
      } else {
        this.busy = false;
        this.message = this.translate.instant(
          'onboarding.messages.vend_not_connected',
        );
      }
    };

    this.checkPOSIntegration();
  }

  ngOnDestroy() {}

  checkPOSIntegration() {
    //Check if the POS is already connected to the selected POS System
    this.busy = true;
    this.posIntegrationService
      .checkPOSIntegration(this.partner.PartnerID, this.selectedPOS.POSID)
      .subscribe(
        (result) => {
          this.message = this.translate.instant(
            'onboarding.messages.vend_connected',
          );
          this.connected = true;
          this.busy = false;
          setTimeout(() => {
            this.message = null;
          }, 10000);
        },
        (err) => {
          this.busy = false;
          this.connected = false;
        },
      );
  }

  connectVend() {
    localStorage.setItem('VendPartnerID', this.partner.PartnerID); //Not Ideal but cant find another easy way to pass this to the other window, and the backend makes it more challenging
    var data = {
      ID: this.partner.PartnerID,
    };
    this.busy = true;
    this.connected = false;
    this.message = null;

    this.win = this.posIntegrationService.launchVendAuthPopup(
      this.vend_auth_url,
    );
    this.checkWindow();
  }

  checkWindow() {
    setTimeout(() => {
      if (this.win.parent === null) {
        this.busy = false;
      } else {
        this.checkWindow();
      }
    }, 2000);
  }

  done() {
    this.next.emit();
  }

  skipToHubtiger() {
    this.router.navigateByUrl('/store/calendar');
  }

  configurationUpdate(event) {
    if (event && event.configurationSaved) {
      this.configurationSaved = true;
    }
  }
}
